import { MEMBERSHIP_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export interface IAddMembershipCategoryResponse {
  status: boolean;
  message: string;
  data: { category_id: string };
}

export interface IAddMembershipCategoryProps {
  category_name: string;
}
export const useAddMembershipCategoryAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: IAddMembershipCategoryProps) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: string | null = await axios
          .post(MEMBERSHIP_MODULE?.ADD_MEMBERSHIP_CATEGORY?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAddMembershipCategoryResponse>) => {
            if (res.data.status === true) {
              toast.success("Category has been added.");
              return res.data.data.category_id;
            } else {
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return null;
          });
        return response;
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
